/**
 * User: n.gorte
 * Date: 04.09.2018
 * Time: 12:30
 */

'use strict';

import React, { useEffect, useRef, useState } from 'external/react';
import PropTypes from 'external/prop-types';
import { BaseRemoteVectorLayerController } from 'plugin/base-portlet';
import { LayerChooserPlugin, Map } from 'plugin/map-portlet';
import { GlobalTerritorialKommune, GlobalTerritorialKreis, GlobalTerritorialRP } from 'plugin/territorial-portlet';
import FliwasOrganizationActions from '../actions/FliwasOrganizationActions';

const LAYERS = {
    commune: GlobalTerritorialKommune,
    district: GlobalTerritorialKreis,
    rp: GlobalTerritorialRP,
};

const TerritorialAreaSelect = ({ type, onChange, formData = {}, propName }) => {
    const [usedTerritorialEntities, setUsedTerritorialEntities] = useState([]);
    const [layerDescriptions, setLayerDescriptions] = useState([]);
    const [layer, setLayer] = useState(LAYERS[type]);
    const initialSelected = useRef((formData[propName] || []).map(id => ({ className: 'TerritorialEntity', id })));
    const layerController = useRef(new BaseRemoteVectorLayerController());
    layerController.current.onItemClick = (className, id, title) => _onChange(id, title);

    useEffect(() => {
        FliwasOrganizationActions.getUsedTerritorialEntities().then(setUsedTerritorialEntities);
    }, []);

    useEffect(() => {
        const l = LAYERS[type];
        const layerDescription = {
            ...l,
            zIndex: 999,
            controller: layerController.current
        };
        setLayer(l);
        setLayerDescriptions([layerDescription]);
    }, [type]);

    const _onChange = (id) => {
        let vals = formData && formData[propName || 'id'].slice() || [];

        const idx = vals.indexOf(id);
        if (idx >= 0) {
            vals.splice(idx, 1);
        } else {
            vals.push(id);
        }
        onChange(propName || 'ids', vals);
    };

    const selectedIds = (formData[propName || 'ids']) || [];
    const selectedItems = selectedIds && selectedIds.map(id => ({ className: 'TerritorialEntity', id }));

    const disabledItems = usedTerritorialEntities
        .map(id => ({ className: 'TerritorialEntity', id }))
        .filter(item => [ ...selectedItems, ...initialSelected.current ].findIndex(s => s.id.toString() === item.id.toString()) < 0);

    return (
        <Map
            selectedItems={selectedItems}
            disabledItems={disabledItems}
            defaultFallbackMapConfigType={'static'}
            plugins={[LayerChooserPlugin]}
            layerDescriptions={layerDescriptions}
            activeUuids={{ [layer.uuid]: true }}
            style={{ height: 500 }}
            zoom={12}
        />
    );
};

TerritorialAreaSelect.propTypes = {
    onChange: PropTypes.func,
    formId: PropTypes.string,
    propName: PropTypes.string,
    type: PropTypes.string,
    formData: PropTypes.object
};

export default TerritorialAreaSelect;







// WEBPACK FOOTER //
// ./js/components/TerritorialAreaSelect.jsx